export default __webpack_public_path__ + "static/media/Diplomovka_Final.06e39d28.pdf";